import {AddrDetailApiResponse} from '@dms/api/core';
import {CommonAddressResponseBody} from '@dms/api/rental';

import {Nullish} from 'shared/web';

export const convertToCommonAddress = (
  address: AddrDetailApiResponse | Nullish
): CommonAddressResponseBody => ({
  street: address?.street ?? '',
  descriptiveNumber: address?.descriptiveNumber ?? null,
  orientationNumber: address?.orientationNumber ?? null,
  city: address?.city ?? '',
  zip: address?.zipCode ?? '',
  addressComplement: null,
  country: address?.country ?? '',
  prefix: address?.prefix ?? null,
  district: null,
  state: address?.state ?? null,
  postal: address?.postal ?? null,
  coordinates:
    address?.gps?.lat && address?.gps?.lng
      ? {
          latitude: address.gps.lat,
          longitude: address.gps.lng,
        }
      : null,
  externalAddressId: address?.placeId ?? null,
});
